import LoadingSpinner, { type LoadingSpinnerProps } from './LoadingSpinner';

export default LoadingSpinner;
export type { LoadingSpinnerProps };
